import React from "react";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import { Box } from "@mui/material";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  inboxTicketType: {
    borderRadius: 2,
    fontSize: 12,
    width: "57px",
    padding: "4px 4px",
    textAlign: "center",
    position: "relative",
    color: "#222222",
    fontWeight: 500,
    lineHeight: "100%",
  },
}));

const TicketStatus = ({ status }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  if (!status) return <Box />;
  let style = {};
  if (status == "Done") style.background = "#D7D7D7";
  if (status == "New") style.background = "#FFF1BE";
  if (status == "Ongoing") style.background = "#F0CECE";
  return (
    <Box className={classes.inboxTicketType} style={style}>
      {status === "Done" && formatMessage({ id: "global.status.done" })}
      {status === "New" && formatMessage({ id: "global.status.new" })}
      {status === "Ongoing" && formatMessage({ id: "global.status.ongoing" })}
    </Box>
  );
};

export default TicketStatus;
